interface mobileUsageResponse {
  period: string
  dateFrom: string
  dateTo: string
  subscriber: string
  usage: mobileUsageResponseUsage[]
}
interface mobileUsageResponseUsage {
  date: string
  national: mobileUsageResponseUsageDataType | undefined
  roaming: mobileUsageResponseUsageDataType | undefined
  internal: mobileUsageResponseUsageDataType | undefined
  premium: mobileUsageResponseUsageDataType | undefined
  roamingOutOfEU: mobileUsageResponseUsageDataType | undefined
}
interface mobileUsageResponseUsageDataType {
  data: { amount: number; cost: number; type: string }
  voice: { amount: number; cost: number; type: string }
  sms: { amount: number; cost: number; type: string }
  mms: { amount: number; cost: number; type: string }
  paymentService: { amount: number; cost: number; type: string }
}
interface mobileUsageRequestBody {
  dateFrom: string
  dateTo: string
  period: string
  subscriber: string | undefined
}

const isMobileUsageResponse = (usage: any): usage is mobileUsageResponse => {
  if (usage === undefined) {
    return false
  }
  if (Array.isArray(usage)) {
    return false
  }
  if ('usage' in usage) {
    return 'national' in usage.usage[0]
  }
  return false
}

const isMobileUsageRequestBody = (usage: any): usage is mobileUsageRequestBody => {
  if (usage === undefined) {
    return false
  }
  return 'dateFrom' in usage
}

export type { mobileUsageResponse, mobileUsageRequestBody, mobileUsageResponseUsage, mobileUsageResponseUsageDataType }
export { isMobileUsageResponse, isMobileUsageRequestBody }
